export default [
  {
    path: "/survey/index/:id",
    component: () => import("@/views/mobile/survey/index.vue"),
    meta: {
      title: "问卷调查",
    },
  },
];
